import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';

const marks = [

  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3',
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 6,
    label: '6',
  },
  {
    value: 7,
    label: '7',
  },
  {
    value: 8,
    label: '8',
  },
  {
    value: 9,
    label: '9',
  },
  {
    value: 10,
    label: '10',
  },
  {
    value: 11,
    label: '11',
  },
  {
    value: 12,
    label: '12',
  },
  {
    value: 13,
    label: '13',
  },
  {
    value: 14,
    label: '14',
  },
  {
    value: 15,
    label: '15',
  },
  {
    value: 16,
    label: '16',
  },
  {
    value: 17,
    label: '17',
  },
  {
    value: 18,
    label: '18',
  },
  {
    value: 19,
    label: '19',
  },
];



function valuetext(value, funky) {
  return value;
}


export default function DiscreteSliderMarks3({setSubjectsSliderValue, compareColour, sliderTitle}) {


    const wrapperStyle = { width: 400, marginRight: 50, marginLeft: 50, marginBottom: 0, marginTop: 0  };
    const handleChange = (event, newValue) => {
    
        setSubjectsSliderValue(newValue);
      };
    
  return (
    <div style={wrapperStyle}>
      <h3 className="widgetLgTitle">{sliderTitle} <Tooltip title="The number of subjects data to run the experiment on.">
        <InfoIcon color='primary' > </InfoIcon>
</Tooltip></h3>

    <Box sx={{ width: 500 }}>
      <Slider
        aria-label="Custom marks"
        defaultValue={1}
        getAriaValueText={valuetext}
        min={1}
        step={1}
        max={19}
        marks={marks}
        onChange={handleChange}
        color={compareColour}
      />
    </Box>
    
    </div>
  );
}
